module.exports = __webpack_public_path__ + "static/Pharmaceuticals-3104da7118618c22c4908cc3ac4cde3e.jpg";